import Select from "components/ui/Select";
import { useAllStates } from "http-hooks/state/usestate";

export default function SelectStates({
  label = "State",
  value,
  onChange,
  isClearable = true,
  isSearchable = true,
  ...props
}) {
  const { data, isLoading } = useAllStates({ ag_status: "1" });

  const options = data?.data?.map((state) => ({
    value: state.stateId,
    label: state.stateName,
    shortcode: state.shortcode,
  })) || [];

  return (
    <Select
      label={label}
      options={options}
      value={value}
      onChange={onChange}
      isLoading={isLoading}
      isClearable={isClearable}
      isSearchable={isSearchable}
      placeholder="Select state..."
      {...props}
    />
  );
}

